// The toast for a refusal the room sends with no message id (#226).
import { useEffect, useRef, useState } from "react";

export const REFUSAL_TOAST_MS = 3500;

/**
 * The words to show, or null. Each notice shows once, for REFUSAL_TOAST_MS: not one this room had before the page
 * opened it, and not again on a re-render. The same words twice are two notices (`n` counts up), so the timer
 * restarts for each.
 */
export function useRefusalToast(room: object | null, notice: { n: number; text: string } | null): string | null {
  const [shown, setShown] = useState<{ n: number; text: string } | null>(null);
  const seen = useRef<{ room: object | null; n: number }>({ room, n: notice?.n ?? 0 });
  useEffect(() => {
    const s = seen.current;
    if (s.room !== room) {
      seen.current = { room, n: notice?.n ?? 0 };
      setShown(null);
      return;
    }
    if (notice && notice.n > s.n) {
      s.n = notice.n;
      setShown(notice);
    }
  }, [room, notice]);
  useEffect(() => {
    if (!shown) return;
    const t = setTimeout(() => setShown(null), REFUSAL_TOAST_MS);
    return () => clearTimeout(t);
  }, [shown]);
  return shown?.text ?? null;
}
